import { API_URL, PRODUCT_PATH } from '../../environment';
  
  const ProductService = () => {
    const _getProduct = async (category, provider, token) => {
      const url = `${API_URL}${PRODUCT_PATH}${category}/${provider}`;
  
      try {
        debugger
        const response = await fetch(url, { method: 'GET',headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }, timeout: 5000 });
        const responseBody = await response.json();
  
        return responseBody;
      } catch (error) {
        console.error(error);
      };
    };
    
    return {
      getProduct: _getProduct,
    };
  };
  
  export default ProductService;